import { PracticeLocation } from '@/core/types/dmp-connect'

export function getBillingNumberFromPracticeLocation(practiceLocation: PracticeLocation) {
  const billingNumber = practiceLocation.s_practiceLocationBillingNumber?.substring(1) || ''
  if (billingNumber && /^\w+$/.test(billingNumber)) {
    return billingNumber
  }
  const structureId = practiceLocation.s_practiceLocationStructureId?.substring(1) || ''
  if (structureId && /^\w+$/.test(structureId)) {
    return structureId
  }
  return ''
}
